import React from 'react';
import Loading from '~/components/Loading';
import ErrorMessage from '~/components/ErrorMessage';
import useCustomQuestionEditor from '~/components/customquestions/useCustomQuestionEditor';
import { EditorColumns } from '~/components/customquestions/CustomQuestionEditorParts';

/**
 * The custom question editor as laid out on its own page. Matches the form
 *  designer's modal (CustomQuestionModalEditor) apart from the heading, which
 *  here carries the breadcrumb and the question's name.
 */
const CustomQuestionEditor = ({ renderHeading, ...options }) => {
    const editor = useCustomQuestionEditor(options);
    const { draft, errors } = editor;

    // Only the first load - a question the assistant just created keeps its
    //  page, and the conversation in it, while it loads
    if (!draft) {
        return <Loading />;
    }

    return (
        <div>
            {renderHeading(draft.name || 'New Custom Question')}

            <ErrorMessage errors={errors} />

            <EditorColumns editor={editor} />
        </div>
    );
};

export default CustomQuestionEditor;
